const generateIndexFromKeys = (keys, i) => `${i}-${keys}--${Math.random()}`;

export default generateIndexFromKeys;
